// src/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('kc_token'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('kc_user') || '{}'));

  const login = (newToken, userInfo) => {
  const payload = JSON.parse(atob(newToken.split('.')[1]));
  const groups = payload?.groups || [];

  const finalUser = { ...userInfo, groups };

  localStorage.setItem('kc_token', newToken);
  localStorage.setItem('kc_user', JSON.stringify(finalUser));
  setToken(newToken);
  setUser(finalUser);
};

  const logout = () => {
    localStorage.removeItem('kc_token');
    localStorage.removeItem('kc_user');
    setToken(null);
    setUser(null);
  };

  useEffect(() => {
    const storedToken = localStorage.getItem('kc_token');
    const storedUser = JSON.parse(localStorage.getItem('kc_user') || '{}');
    if (storedToken) setToken(storedToken);
    if (storedUser) setUser(storedUser);
  }, []);

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
